<template>
  <v-dialog v-model="show2" content-class="dialog-fixed-size dialog-small"
    @keydown.esc="closeDialog" @click.prevent.stop="closeDialog"
    @keydown.enter.stop="validateForm">
    <v-card>
      <v-card-title>
        <h1 class="secondary--text">{{ $t('LBL.PASSWORD_RESET') }}</h1>
      </v-card-title>
      <v-card-text>

        <div v-html="$t('TXT.SETTING_PAGE_RESET_PASSWORD_HELP_HTML')"></div>

        <v-form v-model="passwordResetFormValid" ref="passwordResetForm">
          <v-text-field name="passwordResetEmail" id="passwordResetEmail" required :label="$t('LBL.EMAIL')"
            autocomplete="username"
            v-model="passwordResetEmail" :rules="passwordResetEmailRules"
          ></v-text-field>
        </v-form>

      </v-card-text>
      <v-card-actions class="primary">
        <v-spacer></v-spacer>
        <v-btn flat dark @click.stop="closeDialog" :disabled="loading">{{ $t('LBL.CANCEL') }}</v-btn>
        <v-btn flat dark @click.stop="validateForm" :loading="loading" :disabled="loading">{{ $t('LBL.SEND_RESET_EMAIL') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'

export default {
  name: 'PasswordResetDialog',
  computed: {
    ...mapGetters([
      'userLanguage'
    ])
  },
  data () {
    return {
      passwordResetEmailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.EMAIL')}),
        v => /^\w+([.-]?\w+)*([+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('RULE.FIELD_INVALID_VALUE', {FIELD: this.$i18n.t('LBL.EMAIL')})
      ],
      passwordResetFormValid: null,
      passwordResetEmail: '',
      show2: false,
      loading: false
    }
  },
  methods: {
    validateForm () {
      if (this.$refs.passwordResetForm.validate()) {
        const data = {
          email: this.passwordResetEmail,
          language: this.userLanguage
        }

        if (this.loading) {
          return
        }

        this.loading = true

        this.doRequestPasswordReset(data)
          .then(() => {
            this.showMessage({
              text: this.$i18n.t('MSG.REQUEST_PASSWORD_RESET_SUCCESS'),
              color: 'success'
            })
            this.closeDialog()
          })
          .catch((error) => {
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    closeDialog () {
      this.show2 = false
    },
    ...mapActions({
      doRequestPasswordReset: 'requestPasswordReset'
    }),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    ServerErrorMixin
  ],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (val) {
      this.show2 = val
    },
    show2 (val) {
      if (this.show2 !== this.show) {
        this.$emit('update:show', this.show2)
      }

      if (!val) {
        Vue.nextTick(() => {
          this.$refs.passwordResetForm.reset()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card__text /deep/ ol {
  padding-left: 2.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/PasswordResetDialog.vue